














































import {Component, Prop, Vue} from 'vue-property-decorator';
import Button from '@/components/commons/Button.vue';
import {MeterType, UnitType} from "@/data/models/enums/meter-enum";

@Component({
  components: {Button},
})
export default class ImportCSV extends Vue {
  @Prop({required: true})
  buildingId: string;

  @Prop({required: true})
  opened: boolean;

  file: File = null;
  lineCount: number = 0;

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
    this.file = null;
  }

  get meterType(): string {
    return Object.values(MeterType).join(", ");
  }

  get unit(): string {
    return Object.values(UnitType).join(", ");
  }

  handleImport(): void {
    this.file.text().then((text) => {
      this.lineCount = text.split("\n").length;
    });
  }

  sendFile(): Promise<void> {
    this.$store.commit("showLoader", true);
    return this.file.text().then((text) => {
      this.$dao.meters.importFromCSV(this.buildingId, text).then(() => {
        this.$store.commit("showLoader", false);
        this.dialog = false;
        this.$emit("imported");
      });
    });
  }

}
